export default {
  pt: {
    pageTitle: "Ativações em andamento",
    mainTitle: "Você já tem uma ativação em andamento",
    description: "Continue de onde parou ou inicie uma nova ativação.",
    insuranceNumberLabel: "ID da cotação",
    serialLabel: "Número de série",
    progressTitle: "Progresso da contratação",
    resumeButton: "Continuar de onde parei",
    renewalChip: "Renovação",
    inspectionDeferredChip: "Aguardando inspeção",
    currentJourneyChip: "Jornada atual",
    newJourneyButton: "Começar uma nova contratação",
    newJourneyDialogTitle: "Você já tem uma contratação em andamento",
    newJourneyDialogBody: "Continuar de onde parou é mais rápido, todos os dados que você já preencheu continuam salvos.",
    newJourneyDialogKeepButton: "Continuar minha contratação",
    newJourneyDialogConfirmButton: "Prefiro começar uma nova",
    resumeDialogTitle: "Retomar esta contratação?",
    resumeDialogBody: "Confira os dados abaixo antes de continuar.",
    resumeDialogConfirmButton: "Sim, retomar",
    resumeDialogCancelButton: "Cancelar",
  },

  en: {
    pageTitle: "Journeys in progress",
    mainTitle: "You already have a journey in progress",
    description: "We found other insurance journeys in progress for this phone number. Pick one to continue or start a new one.",
    insuranceNumberLabel: "Insurance number",
    serialLabel: "Serial number",
    progressTitle: "Purchase progress",
    resumeButton: "Resume where I left off",
    renewalChip: "Renewal",
    inspectionDeferredChip: "Awaiting inspection",
    currentJourneyChip: "Current journey",
    newJourneyButton: "Start a new purchase",
    newJourneyDialogTitle: "You already have a purchase in progress",
    newJourneyDialogBody: "Picking up where you left off is faster — everything you've already filled in is saved.",
    newJourneyDialogKeepButton: "Continue my purchase",
    newJourneyDialogConfirmButton: "I'd rather start a new one",
    resumeDialogTitle: "Resume this purchase?",
    resumeDialogBody: "Check the details below before continuing.",
    resumeDialogConfirmButton: "Yes, resume",
    resumeDialogCancelButton: "Cancel",
  },
};
